import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { AdminPricePropertyRepository } from './domain'

import {
  AdminPricePropertyListCriteria,
  AdminPricePropertyListItem,
  AdminPricePropertyView,
} from '../../contracts/treatment'
import {
  AdminPricePropertyModifyRequest,
  AdminPricePropertyRequest,
} from '../../contracts/treatment/AdminPricePropertyRequest'
import { AxiosErrorHandler, SupernovaPagedBody } from '../../foundation'

export class AdminApiPriceProperty implements AdminPricePropertyRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getList = async (
    criteria: AdminPricePropertyListCriteria,
  ): Promise<SupernovaPagedBody<AdminPricePropertyListItem[]>> => {
    const config: AxiosRequestConfig<AdminPricePropertyListCriteria> = {
      url: '/treatment/property/admin/query/price-property-list/process',
      method: 'post',
      data: {
        pagination: criteria.pagination,
      },
    }

    try {
      const { data } = await this.axios.request<SupernovaPagedBody<AdminPricePropertyListItem[]>>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getById = async (id: string): Promise<AdminPricePropertyView> => {
    const config: AxiosRequestConfig<{ id: string }> = {
      url: '/treatment/property/admin/query/price-property/process',
      method: 'post',
      data: { id },
    }

    try {
      const { data } = await this.axios.request<AdminPricePropertyView>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  createProperty = async (command: AdminPricePropertyRequest): Promise<void> => {
    const config: AxiosRequestConfig<AdminPricePropertyRequest> = {
      url: '/treatment/property/admin/command/create-price-property/execute',
      method: 'post',
      data: command,
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  modifyProperty = async (command: AdminPricePropertyModifyRequest): Promise<void> => {
    const config: AxiosRequestConfig<AdminPricePropertyModifyRequest> = {
      url: '/treatment/property/admin/command/modify-price-property/execute',
      method: 'post',
      data: command,
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  enableProperty = async (id: string): Promise<void> => {
    const config: AxiosRequestConfig<{ id: string }> = {
      url: '/treatment/property/admin/command/enable-price-property/execute',
      method: 'post',
      data: { id },
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  disableProperty = async (id: string): Promise<void> => {
    const config: AxiosRequestConfig<{ id: string }> = {
      url: '/treatment/property/admin/command/disable-price-property/execute',
      method: 'post',
      data: { id },
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
